import ToastEventBus from 'primevue/toasteventbus'

type Severity = 'success' | 'info' | 'warn' | 'error'

/**
 * Уведомление Toast из любого места, в том числе вне компонентов (глобальные
 * обработчики ошибок запросов). Тексты передаются уже переведёнными.
 */
export function notify(severity: Severity, summary: string, detail?: string): void {
  ToastEventBus.emit('add', { severity, summary, detail, life: severity === 'error' ? 6000 : 3500 })
}

/** Действие кнопки в уведомлении «Удалено. Отменить». */
export interface UndoAction {
  label?: string
  undo: () => void
}

/** Уведомление с кнопкой отмены: удаление идёт в корзину без подтверждения (ТЗ 14.1). */
export function notifyUndo(summary: string, action: UndoAction): void {
  ToastEventBus.emit('add', {
    group: 'undo',
    severity: 'secondary',
    summary,
    life: 7000,
    data: action,
  })
}
